module.exports = __webpack_public_path__ + "img/Closed_with_mic.ed47e627.gif";